<template>
  <RouterLink to="/" class="font-sans text-3xl text-orange-500">
    Bayardo <span class="text-white">López</span>
  </RouterLink>
</template>

<script>
export default {}
</script>
